import { render, staticRenderFns } from "./clinicalnoteEHRSubMenu.vue?vue&type=template&id=6042d0d2&"
import script from "./clinicalnoteEHRSubMenu.vue?vue&type=script&lang=js&"
export * from "./clinicalnoteEHRSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./clinicalnoteEHRSubMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6042d0d2')) {
      api.createRecord('6042d0d2', component.options)
    } else {
      api.reload('6042d0d2', component.options)
    }
    module.hot.accept("./clinicalnoteEHRSubMenu.vue?vue&type=template&id=6042d0d2&", function () {
      api.rerender('6042d0d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navmenu/clinicalnoteEHRSubMenu.vue"
export default component.exports